import "typeface-muli"
import "@splidejs/react-splide/css"

import { createGlobalStyle } from "styled-components"
import { Theme } from "@life-without-barriers/react-components/src/Interfaces"

// eslint-disable-next-line @typescript-eslint/no-require-imports
require("@life-without-barriers/react-components/fonts/vera-mono/index.css")

export default createGlobalStyle<{
  theme: Theme
}>`
  @keyframes Flow {
    0% { background-position: 0% 50% }
    50% { background-position: 100% 50% }
    100% { background-position: 0% 50% }
  }

  @keyframes Skulk {
    0% { left: -45%; transform:translate(-50%, -50%) rotate(0); }
    40% { left: 10%;  transform:translate(-50%, -50%) rotate(10deg); }
    50% { left: -25%; transform:translate(-50%, -50%); }
    70% { left: -25%; transform:translate(-50%, -50%); }
    100% { left: 200%; transform:translate(-50%, -50%); }
  }

  @keyframes SkulkLarge {
    0% { left: -40%; transform:translate(-50%, -50%) rotate(0); }
    40% { left: 10%;  transform:translate(-50%, -50%) rotate(10deg); }
    50% { left: -20%; transform:translate(-50%, -50%); }
    70% { left: -20%; transform:translate(-50%, -50%); }
    100% { left: 200%; transform:translate(-50%, -50%); }
  }

  @keyframes SkulkIE11 {
    0% { left: -40%; transform:translate(-50%, -50%) rotate(0); }
    40% { left: -10%;  transform:translate(-50%, -50%) rotate(10deg); }
    50% { left: -30%; transform:translate(-50%, -50%); }
    70% { left: -30%; transform:translate(-50%, -50%); }
    100% { left: 200%; transform:translate(-50%, -50%); }
  }

  @keyframes SkulkIEEdge {
    0% { left: -40%; transform:translate(-50%, -50%) rotate(0); }
    40% { left: 10%;  transform:translate(-50%, -50%) rotate(10deg); }
    50% { left: -10%; transform:translate(-50%, -50%); }
    70% { left: -10%; transform:translate(-50%, -50%); }
    100% { left: 200%; transform:translate(-50%, -50%); }
  }

  .flow {
    animation: Flow 25s ease-in-out 1;
  }

  .skulk {
    animation: Skulk 5s ease-in-out 2;
  }

  .skulk-large {
    animation: SkulkLarge 5s ease-in-out 2;

    /** IE10+ hack */
    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {  
      animation-name: SkulkIE11;
    }

    /** IE edge hack */
    @supports (-ms-ime-align:auto) {
      animation-name: SkulkIEEdge;
    }
  }
`
